import React from 'react';

export const NotFoundIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="194"
    height="186"
    viewBox="0 0 194 186"
    fill="none"
  >
    <path
      d="M96.408 184.889C143.957 184.889 182.503 146.343 182.503 98.7935C182.503 51.2444 143.957 12.6982 96.408 12.6982C48.8589 12.6982 10.3127 51.2444 10.3127 98.7935C10.3127 146.343 48.8589 184.889 96.408 184.889Z"
      fill="url(#paint0_linear_2059_6243)"
    />
    <path
      d="M142.855 32.7319H47.48C41.5351 32.7319 36.7158 37.5512 36.7158 43.4961H153.62C153.62 37.5512 148.8 32.7319 142.855 32.7319Z"
      fill="url(#paint1_linear_2059_6243)"
    />
    <path
      d="M36.7158 43.2012H153.62V132.237C153.62 136.196 152.047 139.992 149.248 142.791C146.449 145.59 142.652 147.163 138.694 147.163H51.6417C47.6831 147.163 43.8867 145.59 41.0875 142.791C38.2884 139.992 36.7158 136.196 36.7158 132.237V43.2012Z"
      fill="url(#paint2_linear_2059_6243)"
    />
    <path
      d="M133.525 54.4492H56.8488C55.252 54.4492 53.9575 55.7423 53.9575 57.3374C53.9575 58.9325 55.252 60.2256 56.8488 60.2256H133.525C135.121 60.2256 136.416 58.9325 136.416 57.3374C136.416 55.7423 135.121 54.4492 133.525 54.4492Z"
      fill="url(#paint3_linear_2059_6243)"
    />
    <path
      d="M133.525 78.9893H56.8488C55.252 78.9893 53.9575 80.2823 53.9575 81.8774C53.9575 83.4725 55.252 84.7656 56.8488 84.7656H133.525C135.121 84.7656 136.416 83.4725 136.416 81.8774C136.416 80.2823 135.121 78.9893 133.525 78.9893Z"
      fill="url(#paint4_linear_2059_6243)"
    />
    <path
      d="M133.525 103.531H56.8488C55.252 103.531 53.9575 104.824 53.9575 106.419C53.9575 108.015 55.252 109.308 56.8488 109.308H133.525C135.121 109.308 136.416 108.015 136.416 106.419C136.416 104.824 135.121 103.531 133.525 103.531Z"
      fill="url(#paint5_linear_2059_6243)"
    />
    <path
      d="M133.525 128.072H56.8488C55.252 128.072 53.9575 129.365 53.9575 130.96C53.9575 132.556 55.252 133.849 56.8488 133.849H133.525C135.121 133.849 136.416 132.556 136.416 130.96C136.416 129.365 135.121 128.072 133.525 128.072Z"
      fill="url(#paint6_linear_2059_6243)"
    />
    <g filter="url(#filter0_d_2059_6243)">
      <path
        d="M56.3295 98.2676H15.5008C12.2208 98.2676 9.56177 100.927 9.56177 104.207V162.565C9.56177 165.845 12.2208 168.504 15.5008 168.504H56.3295C59.6096 168.504 62.2686 165.845 62.2686 162.565V104.207C62.2686 100.927 59.6096 98.2676 56.3295 98.2676Z"
        fill="url(#paint7_linear_2059_6243)"
      />
    </g>
    <g filter="url(#filter1_d_2059_6243)">
      <path
        d="M172.556 7.11133H127.459C125.357 7.11133 123.654 8.81489 123.654 10.9163V32.113C123.654 34.2144 125.357 35.918 127.459 35.918H172.556C174.657 35.918 176.361 34.2144 176.361 32.113V10.9163C176.361 8.81489 174.657 7.11133 172.556 7.11133Z"
        fill="url(#paint8_linear_2059_6243)"
      />
    </g>
    <path
      d="M51.7733 127.462H20.0566C18.9886 127.462 18.1228 128.328 18.1228 129.396V129.402C18.1228 130.47 18.9886 131.336 20.0566 131.336H51.7733C52.8413 131.336 53.7071 130.47 53.7071 129.402V129.396C53.7071 128.328 52.8413 127.462 51.7733 127.462Z"
      fill="url(#paint9_linear_2059_6243)"
    />
    <path
      d="M51.7915 154.72H20.3473C19.2885 154.72 18.4302 155.559 18.4302 156.594V156.6C18.4302 157.634 19.2885 158.473 20.3473 158.473H51.7915C52.8503 158.473 53.7087 157.634 53.7087 156.6V156.594C53.7087 155.559 52.8503 154.72 51.7915 154.72Z"
      fill="url(#paint10_linear_2059_6243)"
    />
    <path
      d="M51.7915 140.459H20.3473C19.2885 140.459 18.4302 141.298 18.4302 142.332V142.339C18.4302 143.373 19.2885 144.212 20.3473 144.212H51.7915C52.8503 144.212 53.7087 143.373 53.7087 142.339V142.332C53.7087 141.298 52.8503 140.459 51.7915 140.459Z"
      fill="url(#paint11_linear_2059_6243)"
    />
    <path
      d="M31.6536 107.278H22.3851C20.3321 107.278 18.6677 108.943 18.6677 110.996V113.568C18.6677 115.621 20.3321 117.285 22.3851 117.285H31.6536C33.7066 117.285 35.3709 115.621 35.3709 113.568V110.996C35.3709 108.943 33.7066 107.278 31.6536 107.278Z"
      fill="url(#paint12_linear_2059_6243)"
    />
    <path
      d="M134.784 25.8852C137.2 25.8852 139.158 23.9267 139.158 21.5107C139.158 19.0948 137.2 17.1362 134.784 17.1362C132.368 17.1362 130.409 19.0948 130.409 21.5107C130.409 23.9267 132.368 25.8852 134.784 25.8852Z"
      fill="#81D5E7"
    />
    <path
      d="M150.417 25.8862C152.833 25.8862 154.791 23.9277 154.791 21.5117C154.791 19.0957 152.833 17.1372 150.417 17.1372C148.001 17.1372 146.042 19.0957 146.042 21.5117C146.042 23.9277 148.001 25.8862 150.417 25.8862Z"
      fill="#81D5E7"
    />
    <path
      d="M166.05 25.8862C168.466 25.8862 170.424 23.9277 170.424 21.5117C170.424 19.0957 168.466 17.1372 166.05 17.1372C163.634 17.1372 161.675 19.0957 161.675 21.5117C161.675 23.9277 163.634 25.8862 166.05 25.8862Z"
      fill="#81D5E7"
    />
    <path
      d="M154.189 130.222L143.11 142.437L174.338 170.763L185.418 158.549L154.189 130.222Z"
      fill="url(#paint13_linear_2059_6243)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M165.897 110.006C165.897 135.559 145.183 156.273 119.63 156.273C94.0775 156.273 73.363 135.559 73.363 110.006C73.363 84.4537 94.0775 63.7393 119.63 63.7393C145.183 63.7393 165.897 84.4537 165.897 110.006ZM158.8 110.004C158.8 131.638 141.263 149.175 119.63 149.175C97.9968 149.175 80.4597 131.638 80.4597 110.004C80.4597 88.3713 97.9968 70.8342 119.63 70.8342C141.263 70.8342 158.8 88.3713 158.8 110.004Z"
      fill="url(#paint14_linear_2059_6243)"
    />
    <foreignObject x="67.9437" y="58.3185" width="103.373" height="103.373">
      <div
        className="h-full w-full"
        style={{
          backdropFilter: 'blur(6.26px)',
          clipPath: 'url(#bgblur_0_2059_6243_clip_path)'
        }}
      />
    </foreignObject>

    <path
      data-figma-bg-blur-radius="12.5165"
      d="M119.63 149.175C141.264 149.175 158.801 131.638 158.801 110.005C158.801 88.3721 141.264 70.835 119.63 70.835C97.9973 70.835 80.4602 88.3721 80.4602 110.005C80.4602 131.638 97.9973 149.175 119.63 149.175Z"
      fill="url(#paint15_linear_2059_6243)"
      fill-opacity="0.2"
    />
    <path
      d="M129.043 110.007L140.245 98.7801C141.294 97.6694 141.869 96.1932 141.848 94.6653C141.826 93.1374 141.209 91.6781 140.129 90.5976C139.048 89.5171 137.589 88.9005 136.061 88.8788C134.533 88.8572 133.057 89.4322 131.946 90.4817L120.719 101.709L109.517 90.4817C108.978 89.9112 108.33 89.4546 107.611 89.1389C106.893 88.8232 106.118 88.6548 105.333 88.6437C104.548 88.6325 103.769 88.7789 103.042 89.0741C102.315 89.3694 101.654 89.8074 101.099 90.3624C100.544 90.9174 100.106 91.5781 99.8109 92.3053C99.5157 93.0326 99.3694 93.8116 99.3805 94.5964C99.3916 95.3812 99.56 96.1558 99.8757 96.8744C100.191 97.593 100.648 98.241 101.218 98.7801L112.439 110.007L101.218 121.235C100.648 121.774 100.191 122.422 99.8757 123.14C99.56 123.859 99.3916 124.633 99.3805 125.418C99.3694 126.203 99.5157 126.982 99.8109 127.709C100.106 128.437 100.544 129.097 101.099 129.652C101.654 130.207 102.315 130.645 103.042 130.941C103.769 131.236 104.548 131.382 105.333 131.371C106.118 131.36 106.893 131.192 107.611 130.876C108.33 130.56 108.978 130.104 109.517 129.533L120.744 118.306L131.971 129.533C133.093 130.521 134.548 131.043 136.042 130.995C137.535 130.947 138.954 130.331 140.009 129.273C141.063 128.214 141.675 126.794 141.719 125.3C141.763 123.807 141.236 122.353 140.245 121.235L129.043 110.007Z"
      fill="url(#paint16_linear_2059_6243)"
    />
    <g filter="url(#filter3_f_2059_6243)">
      <ellipse
        cx="120.926"
        cy="131.642"
        rx="27.5362"
        ry="4.06785"
        fill="#EC5575"
        fill-opacity="0.56"
      />
    </g>
    <path
      d="M89.1022 158.661C89.4907 157.052 91.7798 157.052 92.1683 158.661L93.4758 164.078C93.6146 164.653 94.0636 165.102 94.6387 165.241L100.055 166.548C101.664 166.937 101.664 169.226 100.055 169.614L94.6387 170.922C94.0636 171.06 93.6146 171.509 93.4758 172.085L92.1683 177.501C91.7798 179.11 89.4907 179.11 89.1022 177.501L87.7948 172.085C87.6559 171.509 87.2069 171.06 86.6318 170.922L81.2154 169.614C79.6061 169.226 79.6061 166.937 81.2154 166.548L86.6318 165.241C87.2069 165.102 87.6559 164.653 87.7948 164.078L89.1022 158.661Z"
      fill="url(#paint17_linear_2059_6243)"
    />
    <path
      d="M26.8015 14.5455C27.1899 12.9362 29.479 12.9362 29.8675 14.5455L31.175 19.9619C31.3138 20.537 31.7628 20.986 32.3379 21.1248L37.7543 22.4323C39.3636 22.8208 39.3636 25.1099 37.7543 25.4984L32.3379 26.8058C31.7628 26.9447 31.3138 27.3937 31.175 27.9688L29.8675 33.3852C29.479 34.9945 27.1899 34.9945 26.8015 33.3852L25.494 27.9688C25.3552 27.3937 24.9061 26.9447 24.331 26.8058L18.9146 25.4984C17.3053 25.1099 17.3053 22.8208 18.9146 22.4323L24.331 21.1248C24.9061 20.986 25.3552 20.537 25.494 19.9619L26.8015 14.5455Z"
      fill="url(#paint18_linear_2059_6243)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M92.975 15.423C94.4266 15.423 95.6034 14.2462 95.6034 12.7946C95.6034 11.3429 94.4266 10.1661 92.975 10.1661C91.5233 10.1661 90.3466 11.3429 90.3466 12.7946C90.3466 14.2462 91.5233 15.423 92.975 15.423ZM92.975 17.3943C95.5153 17.3943 97.5747 15.3349 97.5747 12.7946C97.5747 10.2542 95.5153 8.19482 92.975 8.19482C90.4346 8.19482 88.3752 10.2542 88.3752 12.7946C88.3752 15.3349 90.4346 17.3943 92.975 17.3943Z"
      fill="url(#paint19_linear_2059_6243)"
    />
    <path
      d="M174.705 87.7987C174.455 86.8184 175.36 85.9351 176.334 86.2088L182.909 88.0562C183.883 88.3299 184.195 89.5553 183.471 90.262L178.584 95.0316C177.86 95.7383 176.642 95.3961 176.393 94.4158L174.705 87.7987Z"
      fill="url(#paint20_linear_2059_6243)"
    />
    <path
      d="M20.6054 76.5131C21.586 76.2644 22.4681 77.1706 22.1932 78.1442L20.3372 84.716C20.0623 85.6896 18.8365 86.0004 18.1308 85.2755L13.3674 80.3823C12.6617 79.6574 13.0054 78.4404 13.9861 78.1917L20.6054 76.5131Z"
      fill="url(#paint21_linear_2059_6243)"
    />
    <path
      d="M145.956 167.337C146.937 167.089 147.819 167.995 147.544 168.968L145.688 175.54C145.413 176.514 144.187 176.825 143.482 176.1L138.718 171.207C138.013 170.482 138.356 169.265 139.337 169.016L145.956 167.337Z"
      fill="url(#paint22_linear_2059_6243)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M180.796 53.7047C182.247 53.7047 183.424 52.5279 183.424 51.0763C183.424 49.6247 182.247 48.4479 180.796 48.4479C179.344 48.4479 178.167 49.6247 178.167 51.0763C178.167 52.5279 179.344 53.7047 180.796 53.7047ZM180.796 55.676C183.336 55.676 185.396 53.6167 185.396 51.0763C185.396 48.5359 183.336 46.4766 180.796 46.4766C178.255 46.4766 176.196 48.5359 176.196 51.0763C176.196 53.6167 178.255 55.676 180.796 55.676Z"
      fill="url(#paint23_linear_2059_6243)"
    />
    <path
      d="M174.336 170.765L185.415 158.55L187.084 160.064C188.703 161.533 189.672 163.584 189.779 165.768C189.885 167.951 189.12 170.087 187.651 171.706C186.183 173.325 184.131 174.295 181.948 174.401C179.764 174.508 177.628 173.742 176.009 172.274L174.34 170.76L174.336 170.765Z"
      fill="url(#paint24_linear_2059_6243)"
    />
    <defs>
      <filter
        id="filter0_d_2059_6243"
        x="0.554497"
        y="92.2627"
        width="75.225"
        height="92.7545"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="2.25182" dy="5.25424" />
        <feGaussianBlur stdDeviation="5.62954" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.104618 0 0 0 0 0.465612 0 0 0 0 0.545833 0 0 0 0.15 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2059_6243"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2059_6243"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_2059_6243"
        x="118.4"
        y="0.355875"
        width="72.2225"
        height="48.3224"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="4.50364" dy="3.00242" />
        <feGaussianBlur stdDeviation="4.87894" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.104618 0 0 0 0 0.465612 0 0 0 0 0.545833 0 0 0 0.09 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2059_6243"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2059_6243"
          result="shape"
        />
      </filter>
      <clipPath
        id="bgblur_0_2059_6243_clip_path"
        transform="translate(-67.9437 -58.3185)"
      >
        <path d="M119.63 149.175C141.264 149.175 158.801 131.638 158.801 110.005C158.801 88.3721 141.264 70.835 119.63 70.835C97.9973 70.835 80.4602 88.3721 80.4602 110.005C80.4602 131.638 97.9973 149.175 119.63 149.175Z" />
      </clipPath>
      <filter
        id="filter3_f_2059_6243"
        x="77.7438"
        y="111.928"
        width="86.3637"
        height="39.4269"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="7.82279"
          result="effect1_foregroundBlur_2059_6243"
        />
      </filter>
      <linearGradient
        id="paint0_linear_2059_6243"
        x1="95.7443"
        y1="-15.3365"
        x2="97.508"
        y2="287.017"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--color-bg-base)" stop-opacity="0" />
        <stop offset="1" stop-color="var(--color-brand-400)" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_2059_6243"
        x1="36.5834"
        y1="35.2161"
        x2="153.678"
        y2="43.4728"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--color-brand-400)" />
        <stop offset="1" stop-color="var(--color-brand-550)" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_2059_6243"
        x1="33.2057"
        y1="121.16"
        x2="202.092"
        y2="124.162"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--color-bg-base)" />
        <stop offset="1" stop-color="#BCF3FF" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_2059_6243"
        x1="50.47"
        y1="59.9874"
        x2="141.293"
        y2="59.9873"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--color-brand-550)" />
        <stop offset="1" stop-color="#D2F7FF" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_2059_6243"
        x1="50.47"
        y1="84.5274"
        x2="141.293"
        y2="84.5274"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--color-brand-550)" />
        <stop offset="1" stop-color="#D2F7FF" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_2059_6243"
        x1="50.47"
        y1="109.069"
        x2="141.293"
        y2="109.069"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--color-brand-550)" />
        <stop offset="1" stop-color="#D2F7FF" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_2059_6243"
        x1="50.47"
        y1="133.61"
        x2="141.293"
        y2="133.61"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--color-brand-550)" />
        <stop offset="1" stop-color="#D2F7FF" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_2059_6243"
        x1="7.97921"
        y1="150.936"
        x2="109.001"
        y2="159.233"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--color-bg-base)" />
        <stop offset="1" stop-color="#BCF3FF" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_2059_6243"
        x1="122.071"
        y1="28.7128"
        x2="198.175"
        y2="30.9142"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--color-bg-base)" />
        <stop offset="1" stop-color="#BCF3FF" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_2059_6243"
        x1="57.8368"
        y1="131.451"
        x2="15.0522"
        y2="131.451"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#D2F7FF" />
        <stop offset="1" stop-color="var(--color-brand-550)" />
      </linearGradient>
      <linearGradient
        id="paint10_linear_2059_6243"
        x1="57.8028"
        y1="158.585"
        x2="15.386"
        y2="158.585"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#D2F7FF" />
        <stop offset="1" stop-color="var(--color-brand-550)" />
      </linearGradient>
      <linearGradient
        id="paint11_linear_2059_6243"
        x1="57.8028"
        y1="144.324"
        x2="15.386"
        y2="144.324"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#D2F7FF" />
        <stop offset="1" stop-color="var(--color-brand-550)" />
      </linearGradient>
      <linearGradient
        id="paint12_linear_2059_6243"
        x1="46.9533"
        y1="117.189"
        x2="16.5538"
        y2="117.189"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.243799" stop-color="#D2F7FF" />
        <stop offset="1" stop-color="#6BCBE0" />
      </linearGradient>
      <linearGradient
        id="paint13_linear_2059_6243"
        x1="150.304"
        y1="148.988"
        x2="161.488"
        y2="136.721"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--color-brand-400)" />
        <stop offset="1" stop-color="var(--color-brand-550)" />
      </linearGradient>
      <linearGradient
        id="paint14_linear_2059_6243"
        x1="73.2582"
        y1="85.0948"
        x2="166.4"
        y2="85.6996"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--color-brand-400)" />
        <stop offset="1" stop-color="var(--color-brand-550)" />
      </linearGradient>
      <linearGradient
        id="paint15_linear_2059_6243"
        x1="119.63"
        y1="70.835"
        x2="159.101"
        y2="173.257"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--color-bg-base)" />
        <stop offset="1" stop-color="#D2F7FF" />
      </linearGradient>
      <linearGradient
        id="paint16_linear_2059_6243"
        x1="99.5829"
        y1="91.5179"
        x2="142.116"
        y2="131.256"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF698D" />
        <stop offset="1" stop-color="#FF3868" />
      </linearGradient>
      <linearGradient
        id="paint17_linear_2059_6243"
        x1="74.829"
        y1="159.59"
        x2="106.577"
        y2="159.796"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--color-brand-400)" />
        <stop offset="1" stop-color="var(--color-brand-550)" />
      </linearGradient>
      <linearGradient
        id="paint18_linear_2059_6243"
        x1="12.5282"
        y1="15.4741"
        x2="44.2765"
        y2="15.6802"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--color-brand-400)" />
        <stop offset="1" stop-color="var(--color-brand-550)" />
      </linearGradient>
      <linearGradient
        id="paint19_linear_2059_6243"
        x1="88.3648"
        y1="10.3179"
        x2="97.6247"
        y2="10.3781"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--color-brand-400)" />
        <stop offset="1" stop-color="var(--color-brand-550)" />
      </linearGradient>
      <linearGradient
        id="paint20_linear_2059_6243"
        x1="171.548"
        y1="92.3636"
        x2="181.075"
        y2="83.1855"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--color-brand-400)" />
        <stop offset="1" stop-color="var(--color-brand-550)" />
      </linearGradient>
      <linearGradient
        id="paint21_linear_2059_6243"
        x1="16.0446"
        y1="73.3501"
        x2="25.2104"
        y2="82.8888"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--color-brand-400)" />
        <stop offset="1" stop-color="var(--color-brand-550)" />
      </linearGradient>
      <linearGradient
        id="paint22_linear_2059_6243"
        x1="141.395"
        y1="164.174"
        x2="150.561"
        y2="173.713"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--color-brand-400)" />
        <stop offset="1" stop-color="var(--color-brand-550)" />
      </linearGradient>
      <linearGradient
        id="paint23_linear_2059_6243"
        x1="176.186"
        y1="48.5997"
        x2="185.446"
        y2="48.6598"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--color-brand-400)" />
        <stop offset="1" stop-color="var(--color-brand-550)" />
      </linearGradient>
      <linearGradient
        id="paint24_linear_2059_6243"
        x1="176.117"
        y1="172.406"
        x2="187.394"
        y2="160.226"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--color-brand-400)" />
        <stop offset="1" stop-color="var(--color-brand-550)" />
      </linearGradient>
    </defs>
  </svg>
);
